export const arrValidateID = [
    'orgIndividualName',
    'orgIndividualEmail',
    'reportComment',
];

export const regArrValidateID = [
    'company_name','username', 'firstname', 'surname', 'email',
    'phone','nationality','nationality','address','city','state',
    'lga','occupation','password', 'passwordAgain'
];
